/* eslint-disable prettier/prettier */
import React from 'react';
import clsx from 'clsx';
import { connect } from 'react-redux';
import Datetime from 'react-datetime';
import compose from 'recompose/compose';
import { withRouter } from 'react-router-dom';
import { v1 as uuidv1 } from 'uuid';

import PropTypes from 'prop-types';

import axios from 'axios';
import firebase, { db, storage } from 'firebase/fbConfig.js';
import moment from 'moment';

import Geocode from 'react-geocode';

// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles';
import { makeStyles } from '@material-ui/core/styles';
import InputAdornment from '@material-ui/core/InputAdornment';
import Icon from '@material-ui/core/Icon';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import Slide from '@material-ui/core/Slide';

// @material-ui/icons
import Face from '@material-ui/icons/Face';
import Email from '@material-ui/icons/Email';
import Check from '@material-ui/icons/Check';
import AddAPhotoIcon from '@material-ui/icons/AddAPhoto';
import Close from '@material-ui/icons/Close';

// import LockOutline from "@material-ui/icons/LockOutline";

// core components
import GridContainer from 'components/Grid/GridContainer.jsx';
import GridItem from 'components/Grid/GridItem.jsx';
import CustomInput from 'components/CustomInput/CustomInput.jsx';
import Button from 'components/CustomButtons/Button.jsx';
import Card from 'components/Card/Card.jsx';
import CardBody from 'components/Card/CardBody.jsx';
import CardHeader from 'components/Card/CardHeader.jsx';
import CardFooter from 'components/Card/CardFooter.jsx';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import styles from 'assets/jss/material-dashboard-pro-react/components/ActionSubmitFormStyle.jsx';
import ShipFullScreenMap from '../../views/Maps/ShipFullScreenMap';
import FormLabel from '@material-ui/core/FormLabel';
import ItemPicUpload from 'components/CustomUpload/ItemPicUpload';
import Snackbar from '@material-ui/core/Snackbar';

import MuiAlert from '@material-ui/lab/Alert';

import DatePicker from 'react-date-picker';
import ExploreAssignUser from '../../views/Explore/ExploreAssignUser';
import EditPartyDateDetails from './EditPartyDateDetails.jsx';
import PartyDetails from './PartyDetails.jsx';
import EditFreight from './EditFreight.jsx';
import PartyFreightSummary from './PartyFreightSummary.jsx';
import PrototypeExploreAssignUser from '../../views/Explore/PrototypeExploreAssignUser';
import { billingToParty, checkBilling, checkParty, checkItems, checkBasic, getMilitaryTime, getCoords, createOrder } from "store/actions/orderActions";
import {
  isEmail,
  isPhoneNumber,
  onlyNumbers,
  onlyLettersAndWhitespace,
} from 'store/actions/formActions.jsx';

const Alert = (props) => {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
};

const FormTransformer = (props) => {
  const roles = ['', 'Shipper', 'Consignee', 'Third Party'];
  const subText = [
    "Tell us who you are and where you're coming from.",
    "Tell us where you're going.",
    'Billing Information.',
    'Tell us what you are shipping.',
    'Please Review Your Shipment Details Prior to Submitting',
  ];
  const {
    display,
    role,
    step,
    steps,
    billingParty,
    classes,
    handleRoleChange,
    handleSelectChange,
  } = props;

  if (steps !== 5) subText.splice(2, 1);

  let roleContainer;

  if (display === 'origin') {
    roleContainer = (
      <div>
        <FormControl fullWidth className={classes.selectFormControl}>
          <InputLabel htmlFor="billingParty" className={classes.selectLabel}>
            BILLING PARTY:
          </InputLabel>
          <Select
            MenuProps={{
              className: classes.selectMenu,
            }}
            classes={{
              select: classes.select,
            }}
            value={billingParty}
            onChange={(e) => handleSelectChange(e)}
            inputProps={{
              id: 'billingParty',
              name: 'billingParty',
            }}
          >
            {roles.map((item) => (
              <MenuItem
                classes={{
                  root: classes.selectMenuItem,
                }}
                value={item}
                key={item}
              >
                {item}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </div>
    );
  }

  let bodyContainer;

  if (display == 'origin' || display == 'destination') {
    bodyContainer = (
      <EditPartyDateDetails
        {...props}
        arr={props[display]}
        arrString={display}
      />
    );
  } else if (display === 'thirdParty') {
    bodyContainer = (
      <PartyDetails {...props} arr={props[display]} arrString={display} />
    );
  } else if (display === 'items') {
    bodyContainer = (
      <EditFreight {...props} arr={props[display]} arrString={display} />
    );
  } else if (display === 'summary') {
    bodyContainer = <PartyFreightSummary {...props} />;
  }

  return (
    <div>
      <h3 className={classes.bodyText}>
        Step {step} of {steps}
      </h3>
      <p>
        <b>{subText[step - 1]}</b>
      </p>

      <GridContainer>
        <GridItem xs={12}>
          {roleContainer}
          {bodyContainer}
        </GridItem>
      </GridContainer>
    </div>
  );
};

class Form extends React.Component {
  state = {
    comment: '',
    queryString: '',
    actionAssigned: false,
    assignedError: false,
    defaultLoaded: false,
    assigningAction: '',
    cardAnimaton: 'cardHidden',
    messageSent: false,
    messageError: false,
    mapDataSaved: true,
    date: new Date(),
  };
  constructor(props) {
    super(props);
    // we use this to make the card to appear after the page has been rendered
    this.state = {
      role: '',
      billingParty: '',
      cardAnimaton: 'cardHidden',
      shippingMode: '',
      pickUpServices: '',
      dropOffServices: '',
      services: '',
      services2: '',
      servicesItem: '',
      error: false,
      groupIDs: [],
      origin: {
        services: [],
        date: !!window.location.pathname.substring(6) ? '' : new Date(),
      },
      destination: {
        services: [],
        date: !!window.location.pathname.substring(6) ? '' : new Date(),
      },
      thirdParty: {},
      items: [{ id: 0 }],
      userSet: false,
      step1: true,
      step: 1,
      steps: 4,
      matchingFlights: [],
      shipperDataLoaded: false,
      dropOffDate: new Date(),
      itemCount: 1,
      orderLoaded: false,
      datesChanged: false,
      clicked: false,
    };
    this.handleToggleServices = this.handleToggleServices.bind(this);
    this.handleToggleItemServices = this.handleToggleItemServices.bind(this);
    this.handleTogglePickupServices = this.handleTogglePickupServices.bind(
      this
    );
  }
  componentDidMount() {
    // we add a hidden class to the card and after 700 ms we delete it and the transition appears
    this.timeOutFunction = setTimeout(
      function () {
        this.setState({ cardAnimaton: '' });
      }.bind(this),
      700
    );
  }

  componentWillUnmount() {
    clearTimeout(this.timeOutFunction);
    this.timeOutFunction = null;
  }

  componentWillUpdate() {
    if (this.state.billingParty === 'Third Party' && this.state.steps !== 5) {
      this.setState({ steps: 5 });
    } else if (
      this.state.billingParty !== 'Third Party' &&
      this.state.steps === 5
    ) {
      this.setState({ steps: 4 });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const itemStep = [this.state.billingParty, this.state.role].includes('Third Party') ? 4 : 3;

    if (this.state.step === itemStep && prevState.step !== itemStep) this.getGroups();
  }

  changeStep = (num) => {
    this.setState({ step: this.state.step + num });
  };

  handleCloseSnack = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    this.setState({
      error: false,
    });
  };

  handleChange = (e) => {
    this.setState({
      [e.target.id]: e.target.value,
    });
    //console.log(this.state)
  };

  handleArrChange = (e, arr) => {
    let array = this.state[arr];
    array[e.target.id] = e.target.value;
    this.setState({
      [arr]: array,
    });
  };

  handleItemChange = (e, i) => {
    let items = this.state.items;
    items[i][e.target.id] = e.target.value;
    this.setState({ items: items });
  };

  onDateChange = (date) => this.setState({ pickUpDate: date });

  handleDateChange = (date, obj) => {
    if (date) {
      let bucket = this.state[obj];
      bucket['date'] = date;
      this.setState({
        [obj]: bucket,
      });
    }
  };

  // only make future selectable
  valid = (current) => {
    return current.isAfter(Datetime.moment().subtract(1, 'day'));
  };

  handleSelectChange = (e) => {
    const changes = {
      [e.target.name]: e.target.value
    }
    if (e.target.value == 'Third Party') changes.thirdParty = this.state.thirdParty || {};

    console.log(changes);
    
    this.setState(changes);
  };

  handleSelectChangeObj = (e, obj) => {
    let bucket = this.state[obj];
    bucket[e.target.name] = e.target.value;
    this.setState({
      [obj]: bucket,
    });
  };

  handleItemSelectChange = (e, i) => {
    let items = this.state.items;
    items[i][e.target.name] = e.target.value;
    this.setState({ items: items });
  };

  handleToggleServices(value, obj) {
    let bucket = this.state[obj];
    let services = bucket['services'];
    const index = services.indexOf(value);

    if (index !== -1) {
      services.splice(index, 1);
    } else {
      services.push(value);
    }

    bucket['services'] = services;

    this.setState({
      [obj]: bucket,
    });
    console.log('point5', this.state);
    console.log(value, obj);
  }

  handleTogglePickupServices(e, newValues) {
    console.log('point5', this.state);
    const obj = this.state.origin;
    obj['services'] = newValues;
    this.setState({
      origin: obj,
    });
  }

  handleToggleDropOffServices(value) {
    const { dropOffServices } = this.state;
    const currentIndex = dropOffServices.indexOf(value);
    const newDropOffServices = [...dropOffServices];

    if (currentIndex === -1) {
      newDropOffServices.push(value);
    } else {
      newDropOffServices.splice(currentIndex, 1);
    }

    this.setState({
      dropOffServices: newDropOffServices,
    });
  }

  handleToggleItemServices(value, iterator) {
    console.log(iterator);
    console.log(value);
    let items = this.state.items;
    value = value.includes(' ') ? value.split(' ').join('') : value;
    items[iterator][`is${value}`] == true
      ? delete items[iterator][`is${value}`]
      : (items[iterator][`is${value}`] = true);
    this.setState({ items: items });
  }

  toggleFootage = (i) => {
    this.setState(
      (prevState) =>
        (prevState.items[i].isFootage = !prevState.items[i].isFootage)
    );
  };

  removePicture = (i, j) => {
    this.setState((prevState) => {
      const { items } = prevState;
      items[i].files.splice(j, 1);
      return {
        items: items,
      };
    });
  };

  uploadImage = (refString, pic) => {
    console.log('Uploading image');
    return new Promise((resolve, reject) => {
      // create storage ref
      var storageRef = storage.ref(refString + pic.name);
      // upload pic
      var uploadTask = storageRef.put(pic);
      // update progress bar
      uploadTask.on(
        'state_changed',
        (snapshot) => {
          // Observe state change events such as progress, pause, and
          // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
          var Progress =
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          this.setState({
            uploadProgress: 'Progress is ' + Progress + '% done',
          });

          switch (snapshot.state) {
            case firebase.storage.TaskState.PAUSED: // or 'paused'
              this.setState({ uploadProgress: ' Upload is paused' });
              break;
            case firebase.storage.TaskState.RUNNING: // or 'running'
              this.setState({ uploadProgress: 'Upload is running' });
              break;
          }
        },
        (error) => {
          // Handle unsuccessful uploads
          console.error(error);
          reject({ message: 'Could not upload image', error: error });
        },
        () => {
          // Handle successful uploads on complete
          // For instance, get the download URL: https://firebasestorage.googleapis.com/...
          uploadTask.snapshot.ref.getDownloadURL().then((downloadURL) => {
            resolve(downloadURL);
          });
        }
      );
    });
  };

  renewItems = async (id, items) => {
    return new Promise((resolve, reject) => {
      db.collection('haney-orders')
        .doc(id)
        .set(
          {
            items: items,
          },
          { merge: true }
        )
        .then(() => {
          resolve(true);
        });
    });
  };

  checkForErrors = () => {
    const errs = [
      checkBasic(this.state),
      checkParty(this.state.origin),
      checkParty(this.state.destination),
      checkBilling(billingToParty(this.state)),
      checkItems(this.state.items)
    ].flat();

    const missing = errs.filter(Boolean);

    if (!missing.length) return false;

    this.setState({ error: true, errorMessage: `Please fill out the following: ${missing[0].msg}` });
    return true;
  }

  handleSubmit = (e) => {
    e.preventDefault();

    const hasErrors = this.checkForErrors();

    if (hasErrors) return;

    this.setState({ clicked: true, });

    const changes = {};

    const { originCoords, destinationCoords } = this.state;

    if (originCoords) {
      if (originCoords.lat || originCoords.lng) {
        changes.originLat = originCoords.lat || null;
        changes.originLng = originCoords.lng || null;
      }
    }
   
    if (destinationCoords) {
      if (destinationCoords.lat || destinationCoords.lng) {
        changes.destinationLat = destinationCoords.lat || null;
        changes.destinationLng = destinationCoords.lng || null;
      }
    }

    createOrder({
      ...this.state,
      ...changes
    }, this.props.user)
      .then(res => {
        window.location.href = '/orders/all-orders';
      })
      .catch(console.error);
  };

  getGroups = async () => {
    const entityID = {
      'Shipper': this.state.origin,
      'Consignee': this.state.destination,
      'Third Party': this.state.thirdParty
    }[this.state.billingParty].entityID;

    const snap = entityID ? await db.collection("haney-shippers").doc(entityID).collection("haney-groups").get() : null;

    const groups = (snap && snap.docs.length) ? snap.docs.map(doc => doc.id) : ["bpn6FBAqZiV3e8mMNWJd"];

    this.setState({ groups });
  };

  saveAsQuote = () => {
    // update firestore document with PENDING and comment
    console.log('saving quote');
    db.collection('TEST-quotes')
      .add({
        uid: this.state.uid ? this.state.uid : null,
        role: this.state.role ? this.state.role : null,
        status: 'pending',
        originBusinessName: this.state.origin['businessName']
          ? this.state.origin['businessName']
          : null,
        originContactName: this.state.origin['contactName']
          ? this.state.origin['contactName']
          : null,
        originContactEmail: this.state.origin['contactEmail']
          ? this.state.origin['contactEmail']
          : null,
        originContactPhone: this.state.origin['contactPhone']
          ? this.state.origin['contactPhone']
          : null,
        originOpenTime: this.state.origin['openTime']
          ? this.state.origin['openTime']
          : null,
        originCloseTime: this.state.origin['closeTime']
          ? this.state.origin['closeTime']
          : null,
        originStartTimeWindow: this.state.origin['startTimeWindow']
          ? this.state.origin['startTimeWindow']
          : null,
        originEndTimeWindow: this.state.origin['endTimeWindow']
          ? this.state.origin['endTimeWindow']
          : null,
        originAddress: this.state.origin['address']
          ? this.state.origin['address']
          : null,
        originCity: this.state.origin['city']
          ? this.state.origin['city']
          : null,
        originState: this.state.origin['state']
          ? this.state.origin['state']
          : null,
        originZip: this.state.origin['zip'] ? this.state.origin['zip'] : null,
        originType: this.state.origin['type']
          ? this.state.origin['type']
          : null,
        pickUpDate: this.state.origin['date']
          ? this.state.origin['date']
          : null,
        pickUpServices: this.state.pickUpServices
          ? this.state.pickUpServices
          : null,
        destinationBusinessName: this.state.destination['businessName']
          ? this.state.destination['businessName']
          : null,
        destinationContactName: this.state.destinationContact['name']
          ? this.state.destinationContact['name']
          : null,
        destinationContactEmail: this.state.destination['email']
          ? this.state.destination['email']
          : null,
        destinationContactPhone: this.state.destination['phone']
          ? this.state.destination['phone']
          : null,
        destinationOpenTime: this.state.destination['openTime']
          ? this.state.destination['openTime']
          : null,
        destinationCloseTime: this.state.destination['closeTime']
          ? this.state.destination['closeTime']
          : null,
        destinationStartTimeWindow: this.state.destination['startTimeWindow']
          ? this.state.destination['startTimeWindow']
          : null,
        destinationEndTimeWindow: this.state.destination['endTimeWindow']
          ? this.state.destination['endTimeWindow']
          : null,
        destinationAddress: this.state.destination['address']
          ? this.state.destination['address']
          : null,
        destinationCity: this.state.destination['city']
          ? this.state.destination['city']
          : null,
        destinationState: this.state.destination['state']
          ? this.state.destination['state']
          : null,
        destinationZip: this.state.destination['zip']
          ? this.state.destination['zip']
          : null,
        destinationType: this.state.destination['type']
          ? this.state.destination['type']
          : null,
        dropOffDate: this.state.dropOffDate ? this.state.dropOffDate : null,
        dropOffServices: this.state.destination.services
          ? this.state.destination.services
          : null,
        services: this.state.services ? this.state.services : null,
        servicesItem: this.state.servicesItem ? this.state.servicesItem : null,
        unNumber: this.state.unNumber ? this.state.unNumber : null,
        properShippingName: this.state.properShippingName
          ? this.state.properShippingName
          : null,
        packaging: this.state.packaging ? this.state.packaging : null,
        quantity: this.state.quantity ? this.state.quantity : null,
        weight: this.state.weight ? this.state.weight : null,
        height: this.state.height ? this.state.height : null,
        width: this.state.width ? this.state.width : null,
        length: this.state.length ? this.state.length : null,
        class: this.state.class ? this.state.class : null,
        deliveryType: this.state.deliveryType ? this.state.deliveryType : null,
        flightNumber: this.state.flightNumber ? this.state.flightNumber : null,
        page: window.location.pathname,
        updatedAt: new Date(),
      })
      .then((docRef) => {
        db.collection('TEST-users')
          .doc(this.state.uid)
          .collection('quotes')
          .doc(docRef.id)
          .set(
            {
              uid: this.state.uid ? this.state.uid : null,
              role: this.state.role ? this.state.role : null,
              status: 'pending',
              originBusinessName: this.state.origin['businessName']
                ? this.state.origin['businessName']
                : null,
              originContactName: this.state.origin['contactName']
                ? this.state.origin['contactName']
                : null,
              originContactEmail: this.state.origin['contactEmail']
                ? this.state.origin['contactEmail']
                : null,
              originContactPhone: this.state.origin['contactPhone']
                ? this.state.origin['contactPhone']
                : null,
              originOpenTime: this.state.origin['openTime']
                ? this.state.origin['openTime']
                : null,
              originCloseTime: this.state.origin['closeTime']
                ? this.state.origin['closeTime']
                : null,
              originStartTimeWindow: this.state.origin['startTimeWindow']
                ? this.state.origin['startTimeWindow']
                : null,
              originEndTimeWindow: this.state.origin['endTimeWindow']
                ? this.state.origin['endTimeWindow']
                : null,
              originAddress: this.state.origin['address']
                ? this.state.origin['address']
                : null,
              originCity: this.state.origin['city']
                ? this.state.origin['city']
                : null,
              originState: this.state.origin['state']
                ? this.state.origin['state']
                : null,
              originZip: this.state.origin['zip']
                ? this.state.origin['zip']
                : null,
              originType: this.state.origin['type']
                ? this.state.origin['type']
                : null,
              pickUpDate: this.state.origin['date']
                ? this.state.origin['date']
                : null,
              pickUpServices: this.state.pickUpServices
                ? this.state.pickUpServices
                : null,
              destinationBusinessName: this.state.destination['businessName']
                ? this.state.destination['businessName']
                : null,
              destinationContactName: this.state.destinationContact['name']
                ? this.state.destinationContact['name']
                : null,
              destinationContactEmail: this.state.destination['email']
                ? this.state.destination['email']
                : null,
              destinationContactPhone: this.state.destination['phone']
                ? this.state.destination['phone']
                : null,
              destinationOpenTime: this.state.destination['openTime']
                ? this.state.destination['openTime']
                : null,
              destinationCloseTime: this.state.destination['closeTime']
                ? this.state.destination['closeTime']
                : null,
              destinationStartTimeWindow: this.state.destination[
                'startTimeWindow'
              ]
                ? this.state.destination['startTimeWindow']
                : null,
              destinationEndTimeWindow: this.state.destination['endTimeWindow']
                ? this.state.destination['endTimeWindow']
                : null,
              destinationAddress: this.state.destination['address']
                ? this.state.destination['address']
                : null,
              destinationCity: this.state.destination['city']
                ? this.state.destination['city']
                : null,
              destinationState: this.state.destination['state']
                ? this.state.destination['state']
                : null,
              destinationZip: this.state.destination['zip']
                ? this.state.destination['zip']
                : null,
              destinationType: this.state.destination['type']
                ? this.state.destination['type']
                : null,
              dropOffDate: this.state.dropOffDate
                ? this.state.dropOffDate
                : null,
              dropOffServices: this.state.destination.services
                ? this.state.destination.services
                : null,
              services: this.state.services ? this.state.services : null,
              servicesItem: this.state.servicesItem
                ? this.state.servicesItem
                : null,
              unNumber: this.state.unNumber ? this.state.unNumber : null,
              properShippingName: this.state.properShippingName
                ? this.state.properShippingName
                : null,
              packaging: this.state.packaging ? this.state.packaging : null,
              quantity: this.state.quantity ? this.state.quantity : null,
              weight: this.state.weight ? this.state.weight : null,
              height: this.state.height ? this.state.height : null,
              width: this.state.width ? this.state.width : null,
              length: this.state.length ? this.state.length : null,
              class: this.state.class ? this.state.class : null,
              deliveryType: this.state.deliveryType
                ? this.state.deliveryType
                : null,
              flightNumber: this.state.flightNumber
                ? this.state.flightNumber
                : null,
              page: window.location.pathname,
              updatedAt: new Date(),
            },
            { merge: true }
          )
          .then(() => {
            this.props.history.push('/quotes');
          })
          .then(() => {
            window.location.reload();
          })
          .catch((err) => {
            console.log(`${err}`);
          });
      })
      .catch((err) => {
        console.log(`${err}`);
      });
  };

  resetRequest = () => {
    window.location.reload();
  };

  setUser = (user) => {
    this.setState({
      uid: user,
      userSet: true,
    });
    console.log(this.state);
  };

  getFlights = (origin, destination) => {
    const axios = require('axios');

    this.setState({
      matchingFlights: [],
      step4: false,
      step5: true,
    });

    // axios({
    //   "method": "GET",
    //   "url": `https://arcane-lowlands-31408.herokuapp.com/https://aerodatabox.p.rapidapi.com/airports/search/location/${origin.lat}/${origin.lng}/km/250/16`,
    //   "headers": {
    //     "content-type": "application/octet-stream",
    //     "x-rapidapi-host": "aerodatabox.p.rapidapi.com",
    //     "x-rapidapi-key": "6e8eead6f7mshdf336167267cb29p1122aejsnb8fac950984e"
    //   }, "params": {
    //     "withFlightInfoOnly": "false"
    //   }
    // })
    //   .then((response) => {
    //     this.setState({
    //       originAirports: response.data,
    //     })
    //     axios({
    //       "method": "GET",
    //       "url": `https://arcane-lowlands-31408.herokuapp.com/https://aerodatabox.p.rapidapi.com/airports/search/location/${destination.lat}/${destination.lng}/km/250/16`,
    //       "headers": {
    //         "content-type": "application/octet-stream",
    //         "x-rapidapi-host": "aerodatabox.p.rapidapi.com",
    //         "x-rapidapi-key": "6e8eead6f7mshdf336167267cb29p1122aejsnb8fac950984e"
    //       }, "params": {
    //         "withFlightInfoOnly": "false"
    //       }
    //     })
    //       .then((response) => {
    //         this.setState({
    //           destinationAirports: response.data,
    //         })
    //         //console.log(this.state.originAirports.items[0].icao)

    //         this.state.originAirports.items.forEach((originAirport) => {
    //           console.log(originAirport.icao)
    //           let originAirportID = originAirport.icao
    //           axios({
    //             "method": "GET",
    //             "url": `https://arcane-lowlands-31408.herokuapp.com/https://aerodatabox.p.rapidapi.com/flights/airports/icao/${originAirport.icao}/${this.state.pickUpAPI}T00:00/${this.state.pickUpAPI}T11:59`,
    //             "headers": {
    //               "content-type": "application/octet-stream",
    //               "x-rapidapi-host": "aerodatabox.p.rapidapi.com",
    //               "x-rapidapi-key": "6e8eead6f7mshdf336167267cb29p1122aejsnb8fac950984e"
    //             }, "params": {
    //               "withLeg": "false",
    //               "direction": "Departure"
    //             }
    //           })
    //             .then((response) => {
    //               this.setState({
    //                 departingFlights: response.data,
    //               })
    //               // console.log(response.data.departures)
    //               // let departingFlightsMatch = response.data.departures.filter(flight => (flight.movement.airport.icao === "KDEN"));
    //               // console.log(departingFlightsMatch)
    //               let filteredDepartingFlights = this.state.matchingFlights
    //               // Parse data into array like in firebase.js
    //               this.state.destinationAirports.items.forEach((destinationAirport) => {
    //                 let departingFlights = response.data.departures.filter(flight => (flight.movement.airport.icao === destinationAirport.icao));
    //                 console.log(destinationAirport)
    //                 console.log(departingFlights)
    //                 if (departingFlights.length > 0) {
    //                   departingFlights.forEach((flight) => {
    //                     let docData = flight
    //                     let docObj = {
    //                       ...docData,
    //                       originAirport: originAirport.icao
    //                     }
    //                     filteredDepartingFlights.push(docObj);
    //                   })
    //                 }
    //               })
    //               console.log(originAirport)
    //               this.setState({
    //                 matchingFlights: filteredDepartingFlights,
    //               })
    //               this.state.originAirports.items.forEach((originAirport) => {
    //                 console.log(originAirport.icao)
    //                 let originAirportID = originAirport.icao
    //                 axios({
    //                   "method": "GET",
    //                   "url": `https://arcane-lowlands-31408.herokuapp.com/https://aerodatabox.p.rapidapi.com/flights/airports/icao/${originAirport.icao}/${this.state.pickUpAPI}T12:00/${this.state.pickUpAPI}T23:59`,
    //                   "headers": {
    //                     "content-type": "application/octet-stream",
    //                     "x-rapidapi-host": "aerodatabox.p.rapidapi.com",
    //                     "x-rapidapi-key": "6e8eead6f7mshdf336167267cb29p1122aejsnb8fac950984e"
    //                   }, "params": {
    //                     "withLeg": "false",
    //                     "direction": "Departure"
    //                   }
    //                 })
    //                   .then((response) => {
    //                     this.setState({
    //                       departingFlights: response.data,
    //                     })
    //                     // console.log(response.data.departures)
    //                     // let departingFlightsMatch = response.data.departures.filter(flight => (flight.movement.airport.icao === "KDEN"));
    //                     // console.log(departingFlightsMatch)
    //                     let filteredDepartingFlights = this.state.matchingFlights
    //                     // Parse data into array like in firebase.js
    //                     this.state.destinationAirports.items.forEach((destinationAirport) => {
    //                       let departingFlights = response.data.departures.filter(flight => (flight.movement.airport.icao === destinationAirport.icao));
    //                       console.log(destinationAirport)
    //                       console.log(departingFlights)
    //                       if (departingFlights.length > 0) {
    //                         departingFlights.forEach((flight) => {
    //                           let docData = flight
    //                           let docObj = {
    //                             ...docData,
    //                             originAirport: originAirport.icao
    //                           }
    //                           filteredDepartingFlights.push(docObj);
    //                         })
    //                       }
    //                     })
    //                     console.log(originAirport)
    //                     this.setState({
    //                       matchingFlights: filteredDepartingFlights,
    //                     })
    //                   })
    //                   .catch((error) => {
    //                     console.log(error)
    //                   })

    //               })
    //             })
    //             .catch((error) => {
    //               console.log(error)
    //             })

    //         })

    //       })
    //       .catch((error) => {
    //         console.log(error)
    //       })
    //     // console.log(response)
    //   })
    //   .catch((error) => {
    //     console.log(error)
    //   })
  };

  saveOrigin = () => {
    const origin = this.state.origin;
    origin.firstName = origin.firstName ? onlyLettersAndWhitespace(origin.firstName).trim() : null;
    origin.lastName = origin.lastName ? onlyLettersAndWhitespace(origin.lastName).trim() : null;
    origin.phone = origin.phone ? onlyNumbers(origin.phone) : null;
    origin.email = origin.email ? origin.email.trim() : null;

    const errs = [
      checkBasic(this.state),
      checkParty(origin),
    ];

    if (this.state.billingParty === 'Shipper') errs.push(checkBilling(billingToParty(this.state)));

    const missing = errs.filter(Boolean);

    if (!missing.length) {
      getCoords(origin)
        .then(originCoords => this.setState({ origin, originCoords, mapDataSaved: true }));
      this.changeStep(1)
    } else {
      this.setState({ error: true, errorMessage: `Please fill out the following: ${missing[0].msg}` });
    }
  };

  saveDestination = () => {
    const destination = this.state.destination;
    destination.firstName = destination.firstName ? onlyLettersAndWhitespace(destination.firstName).trim() : null;
    destination.lastName = destination.lastName ? onlyLettersAndWhitespace(destination.lastName).trim() : null;
    destination.phone = destination.phone ? onlyNumbers(destination.phone) : null;
    destination.email = destination.email ? destination.email.trim() : null;

    const errs = [checkParty(destination)];

    if (this.state.billingParty === 'Consignee') errs.push(checkBilling(billingToParty(this.state)));

    const missing = errs.filter(Boolean);

    if (!missing.length) {
      getCoords(destination)
        .then(destinationCoords => this.setState({ destination, destinationCoords, mapDataSaved: true }));
      this.changeStep(1)
    } else {
      this.setState({ error: true, errorMessage: `Please fill out the following: ${missing[0].msg}` });
    }
  };

  saveThirdParty = () => {
    const thirdParty = this.state.thirdParty;
    thirdParty.firstName = thirdParty.firstName ? onlyLettersAndWhitespace(thirdParty.firstName).trim() : null;
    thirdParty.lastName = thirdParty.lastName ? onlyLettersAndWhitespace(thirdParty.lastName).trim() : null;
    thirdParty.phone = thirdParty.phone ? onlyNumbers(thirdParty.phone) : null;
    thirdParty.email = thirdParty.email ? thirdParty.email.trim() : null;

    const errs = [checkParty(thirdParty)];

    if (this.state.billingParty === 'Third Party') errs.push(checkBilling(billingToParty(this.state)));

    const missing = errs.filter(Boolean);

    if (!missing.length) {
      this.setState({ thirdParty })
      this.changeStep(1)
    } else {
      this.setState({ error: true, errorMessage: `Please fill out the following: ${missing[0].msg}` });
    }
  };

  saveFreight = () => {
    const errs = checkItems(this.state.items);

    if (!errs) {
      this.changeStep(1)
    } else {
      this.setState({ error: true, errorMessage: `Please fill out the following: ${errs[0].msg}` });
    }
  };

  getQuote = () => {
    this.setState({
      step4: false,
      step5: true,
    });
  };

  saveAsQuote = () => {
    this.setState({
      quote: true,
    });
  };

  addItem = () => {
    var items = this.state.items;
    items.push({ id: this.state.items.length });
    this.setState({
      items: items,
      itemCount: this.state.items.length + 1,
    });
  };

  removeItem = () => {
    var items = this.state.items;
    items.pop();
    this.setState({
      items: items,
      itemCount: this.state.items.length - 1,
    });
  };

  viewFreight = () => {
    this.changeStep(-1);
  };

  assignFlightNumber = (flightNumber) => {
    this.setState({
      flightNumber: flightNumber,
    });
  };

  deliveryType = (type) => {
    this.setState({
      deliveryType: type,
    });
  };

  shipperAutoFill = () => {
    this.setState({
      originContactName: this.props.user.firstName,
      shipperAutoFillBool: true,
    });
  };

  loadShipperData = (id) => {
    console.log(id);
    if (id == 'none') {
      this.setState({
        shipperDataLoaded: true,
      });
    } else {
      let data = db
        .collection('haney-shippers')
        .doc(id)
        .get()
        .then(
          (snapshot) => {
            var docData = snapshot.data();
            if (docData) {
              var docObj = {
                ...docData,
                id: snapshot.id,
              };
              return docObj;
            } else {
              return null;
            }
          },
          (error) => {
            console.log('error fetching data: ', error);
          }
        )
        .then((docObj) => {
          this.setState({
            shipperData: docObj,
            shipperDataLoaded: true,
          });
        });
    }
  };

  assignShipper = (doc) => {
    let origin = this.state.origin;
    origin['firstName'] = doc.contactFirstName;
    origin['lastName'] = doc.contactLastName;
    origin['email'] = doc.contactEmail;
    origin['phone'] = doc.contactPhone;
    origin['businessName'] = doc.name;
    origin['address'] = doc.physicalAddress;
    origin['city'] = doc.city;
    origin['state'] = doc.state;
    origin['zip'] = doc.zip;
    this.setState({
      shipper: doc,
      origin: origin,
    });
    console.log(doc);
  };

  assignConsignee = (doc) => {
    let destination = this.state.destination;
    destination['businessName'] = doc.name;
    destination['address'] = doc.physicalAddress;
    destination['city'] = doc.city;
    destination['state'] = doc.state;
    destination['zip'] = doc.zip;
    destination['firstName'] = doc.contactFirstName;
    destination['lastName'] = doc.contactLastName;
    destination['email'] = doc.contactEmail;
    destination['phone'] = doc.contactPhone;
    this.setState({
      consignee: doc,
      destination: destination,
    });
    console.log(doc);
  };

  assignUser = (doc, arr, query, fieldNames) => {
    console.log(doc);
    let user = this.state[arr];
    user['phone'] = doc.cellPhone
      ? doc.cellPhone
      : doc.directPhone
        ? doc.directPhone
        : '';
    user['firstName'] = doc.firstName;
    user['lastName'] = doc.lastName;
    user['email'] = doc.email;

    this.setState({
      [arr]: user,
      [query]: '',
    });
  };

  assignBusiness = (doc, arr, query) => {
    console.log(doc);
    let business = this.state[arr];
    business['businessName'] = doc.name;
    business['address'] = doc.physicalAddress;
    business['city'] = doc.physicalCity;
    business['state'] = doc.physicalState;
    business['zip'] = doc.physicalZip;
    business['entityID'] = doc.id;
    business['ksms'] = doc.ksms ? doc.ksms : false;

    this.setState({
      [arr]: business,
      [query]: '',
    });
  };

  handleParentChange = (e) => {
    this.setState({
      [e.target.id]: e.target.value,
    });
    console.log(this.state);
  };

  assignPic = (files, itemIndex) => {
    const items = this.state.items;
    items[itemIndex].files = files;
    this.setState({ items: items });
  };

  changeDates = () => {
    console.log('changing dates');
    console.log(this.state);

    this.setState({
      destination: {
        ...this.state.destination,
        date: '',
      },
      origin: {
        // object that we want to update
        ...this.state.origin,
        date: '',
      },
    });

    this.setState({ datesChanged: true });
  };

  loadOrderData = (orderID) => {
    console.log('loading order data ' + orderID);
    this.setState({ orderLoaded: true });

    let data = db
      .collection('haney-orders')
      .doc(orderID)
      .get()
      .then(
        (snapshot) => {
          var docData = snapshot.data();
          if (docData) {
            // docData.origin.date = moment.unix(docData.origin.date.seconds, moment.defaultFormat).toDate();
            // docData.destination.date = moment.unix(docData.destination.date.seconds, moment.defaultFormat).toDate();
            var docObj = {
              id: snapshot.id,
              ...docData,
            };
            console.log(docObj);
            return docObj;
          } else {
            return null;
          }
        },
        (error) => {
          console.log('error fetching data: ', error);
        }
      )
      .then((docObj) => {
        this.setState({
          billingParty: docObj.billingParty,
          destination: docObj.destination,
          destinationCoords: docObj.destinationCoords,
          dropOffDate: docObj.dropOffDate,
          dropOffServices: docObj.dropOffServices,
          groups: docObj.groups,
          groupsSet: docObj.groupsSet,
          itemCount: docObj.itemCount,
          items: docObj.items,
          origin: docObj.origin,
          originCoords: docObj.originCoords,
          pickUpServices: docObj.pickUpServices,
          role: docObj.role,
          services: docObj.services,
          services2: docObj.services2,
          servicesItem: docObj.servicesItem,
          shippingMode: docObj.shippingMode,
          thirdParty: docObj.thirdParty,
          orderLoaded: true,
        });
      });
  };

  render() {
    const { classes, modalClose, authUser, user } = this.props;
    function StyledRadio(props) {
      return (
        <Radio
          className={classes.root}
          disableRipple
          color="default"
          checkedIcon={
            <span className={clsx(classes.icon, classes.checkedIcon)} />
          }
          icon={<span className={classes.icon} />}
          {...props}
        />
      );
    }

    // Inspired by blueprintjs
    function StyledRadio(props) {
      return (
        <Radio
          className={classes.root}
          disableRipple
          color="default"
          checkedIcon={
            <span className={clsx(classes.icon, classes.checkedIcon)} />
          }
          icon={<span className={classes.icon} />}
          {...props}
        />
      );
    }

    const shippingModes = ['', 'LTL', 'TL'];
    const role = ['', 'Shipper', 'Consignee', 'Third Party'];
    const militaryTime = [
      '',
      '00:00',
      '01:00',
      '02:00',
      '03:00',
      '04:00',
      '05:00',
      '06:00',
      '07:00',
      '08:00',
      '09:00',
      '10:00',
      '11:00',
      '12:00',
      '13:00',
      '14:00',
      '15:00',
      '16:00',
      '17:00',
      '18:00',
      '19:00',
      '20:00',
      '21:00',
      '22:00',
      '23:00',
    ];
    const locationTypes = [
      '',
      'Business',
      'Construction Site',
      'Convention Center or Tradeshow',
      'Freight Carrier Terminal',
      'Home Based Business',
      'Mlitary Base',
      'Mini-Storage / Self Storage Facility',
      'Religious Institution',
      'Residential / Home',
    ];

    if (authUser && !this.state.userSet) {
      this.setUser(authUser.uid);
    }
    //console.log(authUser)
    // reset modal when closed
    if (this.state.messageSent) {
      this.resetRequest();
    }

    if (
      this.state.role == 'Shipper' &&
      this.props.user &&
      !this.state.shipperAutoFillBool
    ) {
      console.log('Shipper auto fill');
      this.shipperAutoFill();
    }

    console.log(user);
    console.log(user.dataLoaded);

    if (user.dataLoaded && !!user.shipperID && !this.state.shipperDataLoaded) {
      console.log('loading shipper data');
      console.log(user.dataLoaded);
      this.loadShipperData(user.shipperID);
    } else if (
      user.dataLoaded &&
      !user.shipperID &&
      !this.state.shipperDataLoaded
    ) {
      this.loadShipperData('none');
    }

    const newProps = {};

    switch (this.state.step) {
      case 1:
        newProps['display'] = 'origin';
        newProps['origin'] = this.state.origin;
        newProps['step'] = this.state.step;
        newProps['steps'] = this.state.steps;
        newProps['role'] = this.state.role;
        newProps['billingParty'] = this.state.billingParty;
        newProps['businessQuery'] = this.state.businessQuery;
        newProps['userQuery'] = this.state.userQuery;
        newProps['errorMessage'] = this.state.errorMessage;
        newProps['classes'] = this.props.classes;
        newProps['handleChange'] = this.handleChange;
        newProps['handleRoleChange'] = this.handleRoleChange;
        newProps['handleSelectChange'] = this.handleSelectChange;
        newProps['handleSelectChangeObj'] = this.handleSelectChangeObj;
        newProps['handleArrChange'] = this.handleArrChange;
        newProps['assignBusiness'] = this.assignBusiness;
        newProps['assignUser'] = this.assignUser;
        newProps['handleDateChange'] = this.handleDateChange;
        newProps['handleToggleServices'] = this.handleToggleServices;
        newProps['saveOrigin'] = this.saveOrigin;
        newProps[
          'handleTogglePickupServices'
        ] = this.handleTogglePickupServices;
        break;

      case 2:
        newProps['display'] = 'destination';
        newProps['destination'] = this.state.destination;
        newProps['step'] = this.state.step;
        newProps['steps'] = this.state.steps;
        newProps['businessQuery'] = this.state.businessQuery;
        newProps['userQuery'] = this.state.userQuery;
        newProps['errorMessage'] = this.state.errorMessage;
        newProps['classes'] = this.props.classes;
        newProps['changeStep'] = this.changeStep;
        newProps['handleChange'] = this.handleChange;
        newProps['handleSelectChangeObj'] = this.handleSelectChangeObj;
        newProps['handleArrChange'] = this.handleArrChange;
        newProps['assignBusiness'] = this.assignBusiness;
        newProps['assignUser'] = this.assignUser;
        newProps['handleDateChange'] = this.handleDateChange;
        newProps['handleToggleServices'] = this.handleToggleServices;
        newProps['saveDestination'] = this.saveDestination;
        newProps[
          'handleTogglePickupServices'
        ] = this.handleTogglePickupServices;

        break;

      case 3:
        if (this.state.steps === 5) {
          newProps['display'] = 'thirdParty';
          newProps['thirdParty'] = this.state.thirdParty;
          newProps['step'] = this.state.step;
          newProps['steps'] = this.state.steps;
          newProps['businessQuery'] = this.state.businessQuery;
          newProps['userQuery'] = this.state.userQuery;
          newProps['errorMessage'] = this.state.errorMessage;
          newProps['classes'] = this.props.classes;
          newProps['changeStep'] = this.changeStep;
          newProps['handleChange'] = this.handleChange;
          newProps['handleArrChange'] = this.handleArrChange;
          newProps['saveThirdParty'] = this.saveThirdParty;
          newProps['assignBusiness'] = this.assignBusiness;
          newProps['assignUser'] = this.assignUser;
        } else {
          newProps['display'] = 'items';
          newProps['items'] = this.state.items;
          newProps['step'] = this.state.step;
          newProps['steps'] = this.state.steps;
          newProps['itemCount'] = this.state.itemCount;
          newProps['errorMessage'] = this.state.errorMessage;
          newProps['classes'] = this.props.classes;
          newProps['changeStep'] = this.changeStep;
          newProps['addItem'] = this.addItem;
          newProps['removeItem'] = this.removeItem;
          newProps['handleItemChange'] = this.handleItemChange;
          newProps['handleItemSelectChange'] = this.handleItemSelectChange;
          newProps['handleToggleItemServices'] = this.handleToggleItemServices;
          newProps['toggleFootage'] = this.toggleFootage;
          newProps['saveFreight'] = this.saveFreight;
          newProps['onAssignPic'] = this.assignPic;
          newProps['removePicture'] = this.removePicture;
        }

        break;

      case 4:
        if (this.state.steps === 5) {
          newProps['display'] = 'items';
          newProps['items'] = this.state.items;
          newProps['step'] = this.state.step;
          newProps['steps'] = this.state.steps;
          newProps['itemCount'] = this.state.itemCount;
          newProps['errorMessage'] = this.state.errorMessage;
          newProps['classes'] = this.props.classes;
          newProps['changeStep'] = this.changeStep;
          newProps['addItem'] = this.addItem;
          newProps['removeItem'] = this.removeItem;
          newProps['handleItemChange'] = this.handleItemChange;
          newProps['handleItemSelectChange'] = this.handleItemSelectChange;
          newProps['handleToggleItemServices'] = this.handleToggleItemServices;
          newProps['toggleFootage'] = this.toggleFootage;
          newProps['saveFreight'] = this.saveFreight;
          newProps['onAssignPic'] = this.assignPic;
          newProps['removePicture'] = this.removePicture;
        } else {
          newProps['display'] = 'summary';
          newProps['billingParty'] = this.state.billingParty;
          newProps['items'] = this.state.items;
          newProps['origin'] = this.state.origin;
          newProps['destination'] = this.state.destination;
          newProps['thirdParty'] = this.state.thirdParty;
          newProps['step'] = this.state.step;
          newProps['steps'] = this.state.steps;
          newProps['classes'] = this.props.classes;
          newProps['changeStep'] = this.changeStep;
        }

        break;

      case 5:
        newProps['display'] = 'summary';
        newProps['billingParty'] = this.state.billingParty;
        newProps['items'] = this.state.items;
        newProps['origin'] = this.state.origin;
        newProps['destination'] = this.state.destination;
        newProps['thirdParty'] = this.state.thirdParty;
        newProps['step'] = this.state.step;
        newProps['steps'] = this.state.steps;
        newProps['classes'] = this.props.classes;
        newProps['changeStep'] = this.changeStep;

        break;

      default:
        newProps['display'] = 'origin';
        newProps['origin'] = this.state.origin;
        newProps['step'] = this.state.step;
        newProps['steps'] = this.state.steps;
        newProps['role'] = this.state.role;
        newProps['billingParty'] = this.state.billingParty;
        newProps['businessQuery'] = this.state.businessQuery;
        newProps['userQuery'] = this.state.userQuery;
        newProps['errorMessage'] = this.state.errorMessage;
        newProps['classes'] = this.props.classes;
        newProps['handleChange'] = this.handleChange;
        newProps['handleRoleChange'] = this.handleRoleChange;
        newProps['handleSelectChange'] = this.handleSelectChange;
        newProps['handleSelectChangeObj'] = this.handleSelectChangeObj;
        newProps['handleArrChange'] = this.handleArrChange;
        newProps['assignBusiness'] = this.assignBusiness;
        newProps['assignUser'] = this.assignUser;
        newProps['handleDateChange'] = this.handleDateChange;
        newProps['handleToggleServices'] = this.handleToggleServices;
        newProps['saveOrigin'] = this.saveOrigin;
        newProps[
          'handleTogglePickupServices'
        ] = this.handleTogglePickupServices;

        break;
    }

    // console.log(this.props.user)
    console.log(this.state);
    console.log(!!window.location.pathname.substring(6));

    if (!this.state.orderLoaded && !!window.location.pathname.substring(6)) {
      this.loadOrderData(window.location.pathname.substring(6));
    }

    if (
      this.state.orderLoaded &&
      !this.state.datesChanged &&
      !!window.location.pathname.substring(6)
    ) {
      this.changeDates();
    }

    return (
      <div>
        {this.state.messageSent ? (
          <GridContainer justify="center">
            <GridItem xs={11}>
              <h4 className={classes.textPrimary}>Order Submitted!</h4>
            </GridItem>
          </GridContainer>
        ) : (
          <GridContainer style={{ marginTop: '-30px' }} justify="center">
            {this.state.mapDataSaved ? (
              <GridItem xs={12} md={12}>
                <ShipFullScreenMap
                  originCoords={this.state.originCoords}
                  destinationCoords={this.state.destinationCoords}
                />
              </GridItem>
            ) : null}
            <GridItem xs={12} md={12}>
              {this.state.shipperDataLoaded && (
                <div
                  className={classes.formContainer}
                  style={{ marginTop: '20px' }}
                >
                  <form onSubmit={this.handleSubmit}>
                    <GridContainer justify="center">
                      <GridItem xs={11}>
                        {this.state.messageError ? (
                          <h5 className={classes.bodyText}>
                            There Has Been An Error: {this.state.messageError}
                          </h5>
                        ) : null}
                        <FormTransformer {...newProps} />
                        <Snackbar
                          open={this.state.error}
                          autoHideDuration={6000}
                          onClose={this.handleCloseSnack}
                        >
                          <Alert
                            onClose={this.handleCloseSnack}
                            severity="error"
                          >
                            {this.state.errorMessage}
                          </Alert>
                        </Snackbar>
                        <GridContainer>
                          <GridItem xs={6}>
                            {this.state.step > 1 && (
                              <Button
                                color="primary"
                                style={{ marginTop: '20px' }}
                                onClick={() => {
                                  this.changeStep(-1);
                                }}
                              >
                                BACK
                              </Button>
                            )}
                          </GridItem>
                          <GridItem xs={6}>
                            {this.state.step === 1 && (
                              <Button
                                color="primary"
                                style={{ float: 'right', marginTop: '20px' }}
                                onClick={() => this.saveOrigin()}
                              >
                                NEXT
                              </Button>
                            )}
                            {this.state.step === 2 && (
                              <Button
                                color="primary"
                                style={{ float: 'right', marginTop: '20px' }}
                                onClick={() => this.saveDestination()}
                              >
                                NEXT
                              </Button>
                            )}
                            {this.state.step === 3 && this.state.steps === 5 && (
                              <Button
                                color="primary"
                                style={{ float: 'right', marginTop: '20px' }}
                                onClick={() => this.saveThirdParty()}
                              >
                                {console.log('test', this.state)}
                                NEXT
                              </Button>
                            )}

                            {this.state.step === this.state.steps - 1 && (
                              <Button
                                color="primary"
                                style={{ float: 'right', marginTop: '20px' }}
                                onClick={() => this.saveFreight()}
                              >
                                NEXT
                              </Button>
                            )}

                            {this.state.step === this.state.steps && (
                              <Button
                                disabled={this.state.clicked}
                                type="submit"
                                color="primary"
                                style={{
                                  marginTop: '20px',
                                  float: 'right',
                                }}
                              >
                                SUBMIT
                              </Button>
                            )}
                          </GridItem>
                        </GridContainer>
                        <br />
                        <br />
                        <br />
                        <br />
                      </GridItem>
                    </GridContainer>
                  </form>
                </div>
              )}
            </GridItem>
          </GridContainer>
        )}
      </div>
    );
  }
}

Form.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => {
  //console.log(state)
  return {
    AuthBool: !!state.auth.user,
    authUser: state.auth.user,
    user: state.profile.user,
  };
};

// const mapDispatchToProps = (dispatch, ownProps) => {
//   console.log(ownProps)
//   return {
//     startSetList: dispatch(startSetList(ownProps.collection)),
//   }
// }

export default compose(connect(mapStateToProps), withStyles(styles))(Form);



// WEBPACK FOOTER //
// ./src/components/Forms/FeedForms.jsx